import { DumbSelectSport } from '../../filters/select-sport'
import { useSportsForStore } from '../../../../core/hooks/useSports'

interface SelectSportProps {
  onChange: (storeId: number | number[]) => void
  value: number | number[]
  storeId: number
  disabledItemsIds?: number[]
  id?: string
  isMultiple?: boolean
}

const SelectSport = ({ storeId, value, onChange, disabledItemsIds, id, isMultiple }: SelectSportProps) => {
  const { data: sports, isLoading } = useSportsForStore(storeId)
  return (
    <DumbSelectSport
      sports={sports}
      isLoading={isLoading}
      value={value}
      onChange={onChange}
      disabledItemsIds={disabledItemsIds}
      id={id}
      isMultiple={isMultiple}
    />
  )
}

export default SelectSport
